import { render, staticRenderFns } from "./WabaSupsisVolumeBasedPricingTierUpdate.vue?vue&type=template&id=ef08af6a&scoped=true"
import script from "./WabaSupsisVolumeBasedPricingTierUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisVolumeBasedPricingTierUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisVolumeBasedPricingTierUpdate.vue?vue&type=style&index=0&id=ef08af6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef08af6a",
  null
  
)

export default component.exports